// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3M7ZM","inner":"Form_inner__2m-DD","range":"Form_range__2hNmJ","name":"Form_name__2gJUW","actions":"Form_actions__3Zyhs"};